import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // eslint-disable-next-line no-restricted-globals
      window.location.href = `${process.env.VUE_APP_SSO_URL}?continue=${location.origin}`;
    }
    return Promise.reject(error);
  },
);

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
});
app.$mount('#app');
